// Dev cluster (push to `dev`). Built with `--configuration=dev`.
// TODO: confirm the dev hostnames — they must match k8s/ingress.yaml.
const apiServerBaseUrl = 'https://fineshine-api.amritpalbhullar.com';

export const environment = {
  production: false,
  apiUrl: `${apiServerBaseUrl}/api`,
  // Deliberately the production origin: canonical tags on the dev copy point at
  // the real site, so a crawler that finds dev never treats it as the original.
  siteUrl: 'https://fineshinecarwash.co.nz',
  business: {
    name: 'Fine Shine Car Wash',
    phone: '+64 22 452 2580',
    phoneDisplay: '022 452 2580',
    email: 'info@fineshinecarwash.co.nz',
    city: 'Hamilton',
    region: 'Waikato, New Zealand',
  },
};
